module.exports = __webpack_public_path__ + "static/media/quartos.79dd6a2f.svg";